import * as React from 'react';
import { AppProps, AppState } from '../../custom/components/app';
import CalendarContainer from '../../components/calendar-container';
import FiltersContainer from '../../custom/components/filters/container';
import CalendarViewToggle from '../../components/calendar-view-toggle';
import UpNext from '../../custom/components/up-next';
import { CalendarViewMode } from '../../classes/calendar';
import FiltersTagContainer from '../../custom/components/filters/filter-tags';
import { disableTabbableChildren } from '../../../../static/javascript/helpers/disabletabbablechildren'; 
import { stickyFilters } from '../../../shared/helpers/sticky-filters';

export class AppView extends React.Component<AppProps, AppState> {
    public navTop;
    public calFiltersContainer;
    public calFiltersHeight;
    public topNavHeight;
    public filtersAmount;
    public calendarViewMode;
    public filtersAccordion;
    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
        this.topNavHeight = document.getElementById('header').getBoundingClientRect().height;
        if (!this.calFiltersContainer) {
            this.calFiltersContainer = document.querySelector('#aceCalFiltersContainer');
            this.calFiltersHeight = this.calFiltersContainer.getBoundingClientRect().height;
        }
        this.filtersAccordion = (document.querySelector('#filters') as HTMLElement);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    } 

    closeAccordion(accordionToClose) {
        accordionToClose.setAttribute('style', 'height: 0px');
        accordionToClose.setAttribute('aria-hidden', 'true');
        disableTabbableChildren(accordionToClose);
        let id = accordionToClose.id;
        document.querySelector('[aria-controls="' + id + '"]').setAttribute('aria-expanded', 'false');
    }

    handleScroll = () => {
        window.requestAnimationFrame(() => {
            this.setState({
                filtersShouldStick: stickyFilters(this.calFiltersContainer, this.topNavHeight, this.filtersAccordion, () => { this.closeAccordion(this.filtersAccordion) })
            });
        });
    };

    constructor(props: AppProps) {
        super(props);
        this.state = {
            filtersShouldStick: false,
            filtersAmount: 0
        };       
    }

    render() {
        return (
            <section className={"ace-cal " + (this.props.calendarViewMode === CalendarViewMode.GRID ? ' ace-cal-grid-shown' : ' ace-cal-list-shown')} >
                <div>
                    <h1>{this.props.text.calendarHeading}</h1>
                    <CalendarViewToggle />
                </div>
                <div id="aceCalFiltersContainer" className="filters-container">
                    <nav id="filtersNav" className={this.state.filtersShouldStick ? 'filters-sticky' : ''}>
                        <h2 className="visually-hidden">{this.props.text.filtersHeading}</h2>

                        <ul className={`adage-accordion-inner filters-accordion`} data-accordion-list="filtersAccordion">
                            <li className="adage-accordion-item">
                                <button className="adage-accordion-trigger" type="button" aria-controls="filters">
                                    Filter
                                    </button>
                                <div className="adage-accordion-panel" aria-hidden="true" id="filters">
                                    <div className="adage-accordion-panel-content">
                                        <FiltersContainer />
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <FiltersTagContainer />
                    </nav>
                </div>           
                
                <UpNext />

                <div className="ace-cal-main">             
                    <div aria-live="polite">
                        <CalendarContainer />
                    </div>
                </div>
            </section>
        );
    }   
}

export default AppView;